/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Blog_Not_FoundInputs */

const cs_public_site_blog_not_found = /** @type {(inputs: Public_Site_Blog_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Článek nebyl nalezen.`)
};

const en_public_site_blog_not_found = /** @type {(inputs: Public_Site_Blog_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article not found.`)
};

/**
* | output |
* | --- |
* | "Article not found." |
*
* @param {Public_Site_Blog_Not_FoundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_blog_not_found = /** @type {((inputs?: Public_Site_Blog_Not_FoundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Blog_Not_FoundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_blog_not_found(inputs)
	return cs_public_site_blog_not_found(inputs)
});